import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  ComponentFactoryResolver,
  OnChanges,
  OnInit,
  SimpleChanges,
  ViewChild,
  ViewContainerRef
} from '@angular/core';
import {
  FormBuilder,
  FormGroup
} from '@angular/forms';


// import { DatePipe } from '@angular/common';

import { CreatePrivateScheduleComponent } from '../../tests/schedules/create-private-schedule/create-private-schedule.component';
import { CreatePublicScheduleComponent } from '../../tests/schedules/create-public-schedule/create-public-schedule.component';



@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-add-tests-new-schedule',
  templateUrl: './add-tests-new-schedule.component.html',
  styleUrls: ['./add-tests-new-schedule.component.scss'],
})
export class AddTestsNewScheduleComponent implements OnInit, OnChanges, AfterViewInit {

  modeForm: FormGroup;
  @ViewChild('newscheduletemp', { read: ViewContainerRef, static: true }) private newscheduleviewref: ViewContainerRef;
  constructor(private fb: FormBuilder, private cfr: ComponentFactoryResolver) {
    this.modeForm = fb.group({
      mode: ["Public"]
    })
  }

  ngOnInit(): void {
    this.loadPublicScheudle();
    // this.modeForm.get('mode').valueChanges.subscribe(value => {
    //   if (value == 'Public') {

    //     this.loadPublicScheudle();
    //   }
    //   // else if (value == "Private") {

    //   //   this.loadPrivateSchedule();

    //   // }
    // })
  }

  ngAfterViewInit(): void {
    // this.loadPublicScheudle();
    // this.modeForm.get('mode').valueChanges.subscribe(value => {
    //   if (value == 'Public') {

    //     this.loadPublicScheudle();
    //   }
    //   else if (value == "Private") {

    //     this.loadPrivateSchedule();

    //   }
    // })
  }
  loadPublicScheudle() {

    this.newscheduleviewref.clear();
    // const { CreatePublicScheduleComponent } = await import('../../tests/schedules/create-public-schedule/create-public-schedule.component');
    // let greetcomp = this.newscheduleviewref.createComponent(
    //   this.cfr.resolveComponentFactory(CreatePublicScheduleComponent)
    // );
    const factUrl = this.cfr.resolveComponentFactory(CreatePublicScheduleComponent);
    const componentRef = this.newscheduleviewref.createComponent(factUrl);
  }

  loadPrivateSchedule() {

    this.newscheduleviewref.clear();
    // const { CreatePrivateScheduleComponent } = await import('../../tests/schedules/create-private-schedule/create-private-schedule.component');
    // let greetcomp = this.newscheduleviewref.createComponent(
    //   this.cfr.resolveComponentFactory(CreatePrivateScheduleComponent)
    // );
    const factUrl = this.cfr.resolveComponentFactory(CreatePrivateScheduleComponent);
    const componentRef = this.newscheduleviewref.createComponent(factUrl);
    // componentRef.instance.publictemp = 'abc';


  }

  ngOnChanges(changes: SimpleChanges): void {

  }

}
